require('./ui-grid');
module.exports = 'ui.grid';



//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-grid/index.js
// module id = 863
// module chunks = 8